/* Astrak Parts Finder
   Machine data ships as plain-text chunks (pf-m01..pf-mNN.txt) joined with "\n":
     T<tab>type0<tab>type1...          part types
     S<tab>suf0<tab>suf1...            URL suffixes
     X<tab>Make|Model|Type<tab>handle  URL exceptions
     M<tab>MakeName                    starts a make block
     <n><modelTail><tab><codes>        model front-coded against the previous one;
                                       codes are base36 triples (typeIdx, then a
                                       two-char base36 suffixIdx: hi*36 + lo)
   URL = <make-slug>-<model-slug>-<suffix>, unless an exception overrides it. */
(function () {
  'use strict';

  var B36 = '0123456789abcdefghijklmnopqrstuvwxyz';
  var cache = { mach: null, pn: null };

  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function slug(s) {
    return String(s).toLowerCase().replace(/&/g, ' ').replace(/\//g, ' ')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function productUrl(handle) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'products/' + handle;
  }

  function parseMachines(body) {
    var d = { types: [], sufs: [], exc: {}, m: {} };
    var lines = body.split('\n'), cur = null, prev = '';
    for (var i = 0; i < lines.length; i++) {
      var ln = lines[i];
      if (!ln) continue;
      if (ln.indexOf('T\t') === 0) { d.types = ln.slice(2).split('\t'); continue; }
      if (ln.indexOf('S\t') === 0) { d.sufs = ln.slice(2).split('\t'); continue; }
      if (ln.indexOf('X\t') === 0) { var x = ln.split('\t'); d.exc[x[1]] = x[2]; continue; }
      if (ln.indexOf('M\t') === 0) { cur = ln.slice(2); d.m[cur] = {}; prev = ''; continue; }
      if (!cur) continue;
      var tab = ln.indexOf('\t');
      if (tab < 0) continue;
      var model = prev.slice(0, B36.indexOf(ln.charAt(0))) + ln.slice(1, tab);
      prev = model;
      d.m[cur][model] = ln.slice(tab + 1);
    }
    return d;
  }

  function decodeModel(d, make, model, packed) {
    var out = [];
    for (var i = 0; i + 3 <= packed.length; i += 3) {
      var type = d.types[B36.indexOf(packed.charAt(i))];
      var suf = d.sufs[B36.indexOf(packed.charAt(i + 1)) * 36 + B36.indexOf(packed.charAt(i + 2))];
      var key = make + '|' + model + '|' + type;
      out.push({ type: type, handle: d.exc[key] || (slug(make) + '-' + slug(model) + '-' + suf) });
    }
    return out.sort(function (a, b) { return a.type < b.type ? -1 : 1; });
  }

  function reset(sel, placeholder) {
    sel.innerHTML = '<option value="">' + placeholder + '</option>';
    sel.disabled = true;
  }

  function fill(sel, items, placeholder) {
    var html = '<option value="">' + placeholder + '</option>';
    items.forEach(function (it) {
      var val = Array.isArray(it) ? it[0] : it;
      var lab = Array.isArray(it) ? it[1] : it;
      html += '<option value="' + String(val).replace(/"/g, '&quot;') + '">' + lab + '</option>';
    });
    sel.innerHTML = html;
    sel.disabled = false;
  }

  function normalise(s) { return String(s).toLowerCase().replace(/[^a-z0-9]/g, ''); }

  function init(root) {
    var makeSel = root.querySelector('[data-pf-make]');
    var modelSel = root.querySelector('[data-pf-model]');
    var typeSel = root.querySelector('[data-pf-type]');
    var goBtn = root.querySelector('[data-pf-go]');
    var msg = root.querySelector('[data-pf-msg]');

    var indexUrl = root.dataset.indexUrl;
    var chunkUrls = (root.dataset.chunkUrls || '').split(/\s+/).filter(Boolean);
    var pnUrl = root.dataset.pnUrl;
    var pn2Urls = (root.dataset.pn2Urls || '').split(/\s+/).filter(Boolean);
    var searchUrl = root.dataset.searchUrl || '/search';

    /* Localised strings + part-type noun map, supplied by snippets/parts-finder.liquid.
       Part types are translated for DISPLAY ONLY — p.type stays the English lookup key. */
    var I = {};
    try { I = JSON.parse(root.dataset.i18n || '{}'); } catch (e) { I = {}; }
    var TY = I.types || {};
    function t(k, dflt) { return I[k] || dflt; }
    function tyLabel(x) { return TY[x] || x; }

    var state = { make: null, models: null, parts: [] };

    function say(el, text, isError) {
      el.textContent = text || '';
      el.classList.toggle('is-error', !!isError);
    }

    function loadMachines() {
      if (cache.mach) return Promise.resolve(cache.mach);
      return Promise.all(chunkUrls.map(function (u) {
        return fetch(u, { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        });
      })).then(function (parts) {
        cache.mach = parseMachines(parts.join('\n'));
        return cache.mach;
      });
    }

    getJSON(indexUrl).then(function (data) {
      fill(makeSel, data.makes, t('selMake', 'Select manufacturer'));
      makeSel.addEventListener('focus', function () { loadMachines().catch(function () {}); }, { once: true });
    }).catch(function () {
      reset(makeSel, t('unavailable', 'Unavailable'));
      say(msg, t('loadFail', 'The parts finder could not load. Please use the search box instead.'), true);
    });

    makeSel.addEventListener('change', function () {
      var make = makeSel.value;
      reset(modelSel, t('loading', 'Loading…'));
      reset(typeSel, t('modelFirst', 'Select a model first'));
      goBtn.disabled = true;
      say(msg, '');
      if (!make) { reset(modelSel, t('makeFirst', 'Select a make first')); return; }

      loadMachines().then(function (data) {
        state.make = make;
        state.models = data.m[make] || {};
        var models = Object.keys(state.models).sort();
        if (!models.length) { reset(modelSel, t('noModels', 'No models found')); return; }
        fill(modelSel, models, t('selModel', 'Select model'));
      }).catch(function () {
        reset(modelSel, t('unavailable', 'Unavailable'));
        say(msg, t('modelsFail', 'Could not load models for {make}.').replace('{make}', make), true);
      });
    });

    modelSel.addEventListener('change', function () {
      reset(typeSel, t('modelFirst', 'Select a model first'));
      goBtn.disabled = true;
      say(msg, '');
      var model = modelSel.value;
      if (!model || !state.models) return;

      state.parts = decodeModel(cache.mach, state.make, model, state.models[model] || '');
      if (!state.parts.length) { reset(typeSel, t('noParts', 'No parts found')); return; }

      fill(typeSel, state.parts.map(function (p, i) { return [i, tyLabel(p.type)]; })
        .sort(function (a, b) { return String(a[1]).localeCompare(String(b[1])); }),
        t('selType', 'Select part type'));
      if (state.parts.length === 1) {
        typeSel.value = '0';
        goBtn.disabled = false;
        say(msg, t('oneType', 'One part type available for this machine.'));
      }
    });

    typeSel.addEventListener('change', function () { goBtn.disabled = typeSel.value === ''; });

    function go() {
      var p = state.parts[Number(typeSel.value)];
      if (p) window.location.href = productUrl(p.handle);
    }
    goBtn.addEventListener('click', go);
    [makeSel, modelSel, typeSel].forEach(function (el) {
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !goBtn.disabled) { e.preventDefault(); go(); }
      });
    });

    var pnInput = root.querySelector('[data-pf-pn]');
    if (pnInput) {
      var pnBtn = root.querySelector('[data-pf-pn-go]');
      var pnMsg = root.querySelector('[data-pf-pn-msg]');
      var sugg = root.querySelector('[data-pf-suggest]');

      /* Two lists drive the part-number search: pf-partnumbers.json (part
         numbers) plus the pf-pn2-*.json files (OEM alternate part numbers,
         removed from the machine model dropdown). The alternate lists are
         merged in at load time; any that fail to load are skipped, so search
         continues on whatever loaded. */
      var loadPN = function () {
        if (cache.pn) return Promise.resolve(cache.pn);
        var alts = Promise.all(pn2Urls.map(function (u) {
          return getJSON(u).catch(function () { return null; });
        }));
        return getJSON(pnUrl).then(function (d) {
          return alts.then(function (list) {
            list.forEach(function (d2) {
              if (!d2 || !d2.pn) return;
              for (var k in d2.pn) {
                d.pn[k] = d.pn[k] ? d.pn[k].concat(d2.pn[k]) : d2.pn[k];
              }
            });
            cache.pn = d;
            return d;
          });
        });
      };
      var pnHandle = function (d, rec) {
        if (rec[1] === -2) return rec[2];
        /* brand can be blank for part-number-only products — no empty prefix */
        var brand = rec[1] >= 0 ? d.brands[rec[1]] : '';
        var pre = brand ? slug(brand) + '-' : '';
        return pre + slug(rec[0]) + '-' + d.sufs[rec[2]];
      };
      pnInput.addEventListener('focus', function () { loadPN().catch(function () {}); }, { once: true });

      var suggest = function () {
        var q = normalise(pnInput.value);
        var d = cache.pn;
        if (q.length < 3 || !d) { sugg.hidden = true; return; }
        var hits = [];
        for (var k in d.pn) {
          if (k.indexOf(q) === 0) {
            d.pn[k].forEach(function (rec) { hits.push(rec); });
            if (hits.length >= 8) break;
          }
        }
        if (!hits.length) { sugg.hidden = true; return; }
        sugg.innerHTML = hits.slice(0, 8).map(function (rec) {
          return '<li><button type="button" data-handle="' + pnHandle(d, rec) + '">' +
                 '<strong>' + rec[0] + '</strong></button></li>';
        }).join('');
        sugg.hidden = false;
      };
      pnInput.addEventListener('input', function () { loadPN().then(suggest).catch(function () {}); });
      sugg.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-handle]');
        if (b) window.location.href = productUrl(b.dataset.handle);
      });

      var pnGo = function () {
        var raw = pnInput.value.trim();
        if (!raw) return;
        loadPN().then(function (d) {
          var hit = d.pn[normalise(raw)];
          if (hit && hit.length === 1) window.location.href = productUrl(pnHandle(d, hit[0]));
          else if (hit) { say(pnMsg, t('manyMatch', '{n} parts match that number — pick one below.').replace('{n}', hit.length)); suggest(); }
          else window.location.href = searchUrl + '?q=' + encodeURIComponent(raw);
        }).catch(function () {
          window.location.href = searchUrl + '?q=' + encodeURIComponent(raw);
        });
      };
      pnBtn.addEventListener('click', pnGo);
      pnInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); pnGo(); }
      });
      document.addEventListener('click', function (e) { if (!root.contains(e.target)) sugg.hidden = true; });
    }

    var tabs = [].slice.call(root.querySelectorAll('[data-pf-tab]'));
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        [].slice.call(root.querySelectorAll('[data-pf-panel]')).forEach(function (p) {
          p.classList.toggle('is-hidden', p.dataset.pfPanel !== tab.dataset.pfTab);
        });
      });
    });
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-pf]')).forEach(function (el) {
      if (!el.dataset.pfReady) { el.dataset.pfReady = '1'; init(el); }
    });
  }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState !== 'loading') boot();
})();
